export default "Royal Escapes opened in May 2021. Their location was previously used by the now closed WayOut Copenhagen.";